module.exports = __webpack_public_path__ + "logo-43527c25.png";